export const initCommon = () => {
	// ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	// ローディング画面 ＆ MVアニメーション
	// ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	const loader = document.getElementById("js-loader");
	const keyName = "visited_homepage";
	// メインビジュアルの要素を取得
	const mainVisual = document.querySelector(".t-mainvisual");
	const pageTitle = document.querySelector(".page-title"); // 下層ページのタイトル
	// アニメーションを開始する関数
	const startMvAnimation = () => {
		if (mainVisual) {
			mainVisual.classList.add("is-mv-active");
		}
		// 下層ページタイトルがあればクラス付与
		if (pageTitle) {
			pageTitle.classList.add("is-loaded");
		}
	};

	// WordPressのトップページ判定
	const isHome = document.body.classList.contains("home") || document.body.classList.contains("front-page");

	if (loader) {
		// ▼ パターンA：トップページ かつ 初回アクセス
		if (isHome && !sessionStorage.getItem(keyName)) {
			// 3秒待機
			setTimeout(() => {
				loader.classList.add("is-hidden");
				sessionStorage.setItem(keyName, "true");

				// ローダーが消え始めたらMVアニメーション開始
				startMvAnimation();
			}, 2000);

			// ▼ パターンB：それ以外（2回目以降 or 下層）
		} else {
			loader.classList.add("is-hidden");
			startMvAnimation();
		}
	} else {
		// 万が一ローダーが無いページでもMVがあればアニメーションさせる
		startMvAnimation();
	}

	// ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	// ハンバーガーメニュー
	// ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	const hamburger = document.querySelector(".hamburger-menu");
	const navBox = document.querySelector(".nav-box");

	if (hamburger && navBox) {
		// メニューの開閉
		hamburger.addEventListener("click", (e) => {
			e.stopPropagation();
			hamburger.classList.toggle("active");
			navBox.classList.toggle("show");
		});

		// 【最強版】メニュー内がクリックされたら、中身をチェックして閉じる
		navBox.addEventListener("click", (e) => {
			// クリックされた要素、またはその親要素に <a> タグがあるか探す
			const targetLink = e.target.closest("a");

			if (targetLink) {
				const href = targetLink.getAttribute("href") || "";

				// 1. 同じページ内のアンカーリンク（#を含む）
				// 2. HOMEへのリンク（/ または 自ドメインのTOP）
				// 3. ただし、別タブで開くリンク（target="_blank"）は除外する
				if ((href.includes("#") || href === "/" || href === window.location.origin + "/") && targetLink.getAttribute("target") !== "_blank") {
					hamburger.classList.remove("active");
					navBox.classList.remove("show");
				}
			}
		});
	}
	// ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	// PC時のHOMEホバー挙動 (フォーカス対応)
	// ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	const navItems = document.querySelectorAll(".nav-list > li");

	navItems.forEach((item) => {
		const anchor = item.querySelector("a, .list-item");
		const inner = item.querySelector(".list-item-inner");

		// anchor と inner 両方がある場合のみイベントを設定（エラー防止）
		if (anchor && inner) {
			anchor.addEventListener("focus", () => {
				inner.style.opacity = "1";
				inner.style.visibility = "visible";
				inner.style.transform = "translateX(-50%) translateY(0)";
			});
		}
	});

	// ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	// ヘッダーのスクロール検知
	// ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	const header = document.querySelector(".section-header");
	if (header) {
		window.addEventListener("scroll", () => {
			header.classList.toggle("is-scrolled", window.scrollY > 0);
		});
	}

	// ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	// ページトップに戻るボタン
	// ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝
	const pageTopBtn = document.querySelector(".js-page-top");

	if (pageTopBtn) {
		// returnを使わず if で囲む
		pageTopBtn.addEventListener("click", (e) => {
			e.preventDefault();
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		});
	}
};
